export const UPDATE_MARKET_CYCLE_FILTERS = 'UPDATE_MARKET_CYCLE_FILTERS';
export const updateMarketCycleFilters = (e) => ({
  type: UPDATE_MARKET_CYCLE_FILTERS,
  payload: e,
});

export const UPDATE_MARKET_CYCLE_FILTERS_INPUT_INTERVALS =
  'UPDATE_MARKET_CYCLE_FILTERS_INPUT_INTERVALS';
export const updateMarketCycleFiltersInputIntervals = (e) => ({
  type: UPDATE_MARKET_CYCLE_FILTERS_INPUT_INTERVALS,
  payload: e,
});

export const CLEAR_FILTERS_MARKET_CYCLE = 'CLEAR_FILTERS_MARKET_CYCLE';
export const clearFiltersMarketCycle = (e) => ({
  type: CLEAR_FILTERS_MARKET_CYCLE,
  payload: e,
});

export const UPDATE_REQUEST_STATUS_MARKET_CYCLE =
  'UPDATE_REQUEST_STATUS_MARKET_CYCLE';
export const updateRequestStatusMarketCycle = (e) => ({
  type: UPDATE_REQUEST_STATUS_MARKET_CYCLE,
  payload: e,
});

export const SET_MARKET_CYCLE_TIMEFRAME = 'SET_MARKET_CYCLE_TIMEFRAME';
export const setMarketCycleTimeframe = (e) => ({
  type: SET_MARKET_CYCLE_TIMEFRAME,
  payload: e,
});

export const UPDATE_CHARTS_DATA_MARKET_CYCLE =
  'UPDATE_CHARTS_DATA_MARKET_CYCLE';
export const updateChartsDataMarketCycle = (e) => ({
  type: UPDATE_CHARTS_DATA_MARKET_CYCLE,
  payload: e,
});
